/**
 * @deprecated
 * WA-649
 * Please don't use this!
 * If you're tempted to use it you're probably doing the wrong thing!
 *
 * Ask Web Arch team for more information.
 *
 * TODO WA-649 - remove this
 */
export const encodeColour = (colour: string | undefined | null) => {
  return (
    colour &&
    colour
      ?.trim()
      .toLowerCase()
      .replace(/\s|\//g, "-")
      .replace(/['"(),]/g, "") // eslint-disable-line no-useless-escape
      .replace(/-+/g, "-")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
  );
};
